
import { Component, Input, NgZone, OnChanges, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { Auth } from 'aws-amplify';
import { Router } from '@angular/router';
import { CacheService } from '../services/cache.service';
import { UserService } from '../services/user.service';
import { ConstantsService } from '../services/constants.service';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
  isLoading: boolean;
  profilePicture: any;
  login: boolean;
  userName: any;
  isPrime: any;
  @Input() from = '';
  @Input() isMobile = false;
  @Input() isMapsearchResult
  @Input() dateRecording = '';
  @Input() timeRecording = ''

  constructor(
    private router: Router,
    private zone: NgZone,
    private authenticate: CacheService,
    private userService: UserService,
    public constants: ConstantsService,
    private mixpanel: SharedMixpanelService
  ) {
  }

  ngOnInit(): void {  
    this.authcall();
    this.userService.profilePicture$.subscribe((newPictureUrl: string)=>{
      this.profilePicture = newPictureUrl;
    })
  }

  public async authcall() {
    this.authenticate.getAuthUser()
      .then(async (data) => {
        let { login } = data;
        this.login = login;
        if (login) {
          this.profilePicture = data.hasOwnProperty('picture')?data.picture:this.constants.AVATAR_IMG;
          await this.userService.getUser(true).then(async data => {
            let { isPrime } = data;
            this.profilePicture = data.hasOwnProperty('pictureUrl')?data.pictureUrl:this.profilePicture;
            this.isPrime = isPrime === undefined ? true : isPrime;
          })
        }
        else {
          this.isPrime = false
        }
      })
  }


  Takemetoprime() {
    if (!this.login) {
      this.router.navigate(['/signup']);
      localStorage['fromwindowBookmark'] = JSON.stringify(true);
      localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([this.authenticate.get()]);
    }
    else {
      this.router.navigate(['/pricing']);
    }
  }
  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.mixpanel.actions.reset()
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }
}

